import { Injectable } from "@angular/core";
import { LoggerService } from "../../../infra/logger/logger.service";
import { HttpService } from "../../http/http.service";
import { map, Observable } from "rxjs";
import { PreventionMockModel } from "src/app/models/api/preventionMock.model";
import { HttpClient } from "@angular/common/http";

@Injectable({
    providedIn: "root",
})
export class AiPreventionMockHttpService {
    public readonly defaultPageSize: number = 50;

    constructor(
        private _httpClient: HttpClient,
        private _httpService: HttpService,
        private _logger: LoggerService,
    ) {}

    public getPreventionMockData(): Observable<PreventionMockModel[]> {
        return this._httpClient.get<PreventionMockModel[]>("assets/mockData/aiPreventionMockData.json");
    }

    public getPreventionMockDetails(preventionId: string): Observable<PreventionMockModel> {
        return this.getPreventionMockData().pipe(
            map((prevention: PreventionMockModel[]) => {
                const preventionDetails = prevention.find((preventionDetails) => preventionDetails.id === preventionId);
                if (!preventionDetails) {
                    throw new Error(`Prevention with id ${preventionId} not found`);
                }
                return preventionDetails;
            }),
        );
    }
}
